import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import ReactDOM from 'react-dom/client';
import './index.css';
import Home from './client/components/Home';
import AboutUs from './client/components/aboutus';
import Login from './client/components/login';
import ServiceOne from './client/components/serviceOne';
import CommmunitySupport from './client/components/communitySupport';
import CommmunityNursing from './client/components/communityNursing';
import GroupBasedActivities from './client/components/groupBasedActivities';
import Contact from './client/components/contact';
import AgedCare from './client/components/agedCare';
import OurStory from './client/components/ourStory';
import Categories from './client/components/categories';
import CategoryDetail from './client/components/categoryDetail';
import NdisResource from './client/components/ndisResource';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />}>
        </Route>
        <Route path="/our-story" element={<OurStory />}>
        </Route>
        <Route path="/resources" element={<Categories />}>
        </Route>
        <Route path="/resources/ndis" element={<NdisResource />}>
        </Route>
        <Route path="/resources/aged-care" element={<Categories />}>
        </Route>
        <Route path="/categories/:itemId" element={<CategoryDetail />}>
        </Route>
        <Route path="/resources/:itemId" element={<CategoryDetail />}>
        </Route>
        <Route path="/aged-care/:itemId" element={<CategoryDetail />}>
        </Route>
        <Route path="/categories" element={<Navigate to="/resources" replace />}>
        </Route>
        <Route path="/serviceOne" element={<ServiceOne />}>
        </Route>
        <Route path="/communitySupport" element={<CommmunitySupport />}>
        </Route>
        <Route path="/communityNursing" element={<CommmunityNursing />}>
        </Route>
        <Route path="/groupBasedActivities" element={<GroupBasedActivities />}>
        </Route>
        <Route path="/login" element={<Login />}>
        </Route>
        <Route path="/aboutus" element={<AboutUs />}>
        </Route>
        <Route path="/contact" element={<Contact />}>
        </Route>
        <Route path="/aged-care" element={<AgedCare />}>
        </Route>
      </Routes>
    </BrowserRouter>
  </>
);

